import { render, staticRenderFns } from "./PresentationDownload.vue?vue&type=template&id=5736c426&"
import script from "./PresentationDownload.vue?vue&type=script&lang=js&"
export * from "./PresentationDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports